import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationStatus } from 'app/actions/CommunicationStatusActions';
import { getCommunicationStatus, getIsLoadingCommunicationStatus } from 'app/reducers';
import moment from 'moment';
import isEmpty from 'app/utils/IsEmpty';

export default function CommunicationStatusContainer(props) {

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Cod. procedimiento',
            dataIndex: 'courseCode',
            key: 'courseCode',
            sorter: true,
        },
        {
            title: 'Nombre procedimiento',
            dataIndex: 'courseName',
            key: 'courseName',
            sorter: true,
        },
        {
            title: 'PDC',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            render: (id, i) => {
                return <div>
                    <Tooltip placement="bottomLeft" title={id}>
                        {id}
                    </Tooltip>
                </div>
            }
        },
        {
            title: 'Contrato',
            dataIndex: 'contractName',
            key: 'contractName',
            sorter: true
        },
        {
            title: 'Obra',
            dataIndex: 'workName',
            key: 'workName',
            sorter: true

        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true
        },
        {
            title: 'Fecha de program.',
            dataIndex: 'diffusionStartDate',
            key: 'diffusionStartDate',
            sorter: true,
            render: (date) => {
                if (date.includes('-'))
                    return moment(new Date(date)).locale('es').format('L')
                else
                    return date.charAt(0) + date.slice(1).toLowerCase();
            }
        },
        {
            title: 'Fecha Evaluación Teórica',
            dataIndex: 'communicationDate',
            key: 'communicationDate',
            sorter: true,
            render: (date) => {
                if (date.includes('-')) {
                    return moment(date).format('DD/MM/YYYY')
                }
                else
                    return date.charAt(0) + date.slice(1).toLowerCase();
            }
        },
        {
            title: 'Fecha Evaluación CT',
            dataIndex: 'responsibleDate',
            key: 'responsibleDate',
            sorter: true,
            render: (date) => {
                if (date.includes('-'))
                    return moment(date).format('DD/MM/YYYY')
                else
                    return date.charAt(0) + date.slice(1).toLowerCase();
            }
        },
    ];

    let communicationProgram = useSelector(getCommunicationStatus);

    let isLoading = useSelector(getIsLoadingCommunicationStatus);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(communicationProgram.communicationStatus)) fetchCommunicationStatusAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchCommunicationStatus(props.idEmployee,
            {
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };
    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && communicationProgram.length > 0) {
            pagination.total = communicationProgram[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchCommunicationStatusAction = () => dispatch(fetchCommunicationStatus(props.idEmployee, {
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    return (props.children({ pagination: pagination, cols: columns, communicationProgram, isLoading, handleTableChange: handleTableChange }));
}
